<template>
  <div id="logo_box">
  	<ul>
  		<li><img src="../assets/logo_store.svg" alt="DroneAgent"></li>
  		<li><img src="../assets/logo_kusatu.svg" alt="DroneAgent"></li>
  		<li><img src="../assets/logo_camp.svg" alt="DroneCamp"></li>
  		<li><img src="../assets/logo_care.svg" alt="DroneAgentケア"></li>
  	</ul>
  </div>
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style scoped>
  @import '../assets/css/logo.css'
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue